export const listProviderMappings = `
    query listProviderMappings($filter: ProviderMappingsFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
        listProviderMappings(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
            items {
                id
                entityType
                localEntityId
                billingProviderId
                billingProvider {
                    id
                    name
                    description
                }
                providerEntityId
                syncStatus
                providerSpecificData
                lastSyncAt
                syncError
                created
                updated
                createdByUsername
                createdByUser {
                    username
                    givenName
                    familyName
                }
            }
            nextToken
        }
    }
`;

export const getProviderMapping = `
    query getProviderMapping($id: ID!) {
        getProviderMapping(id: $id) {
            id
            entityType
            localEntityId
            billingProviderId
            billingProvider {
                id
                name
                description
            }
            providerEntityId
            syncStatus
            providerSpecificData
            lastSyncAt
            syncError
            created
            updated
            createdByUsername
            createdByUser {
                username
                givenName
                familyName
            }
        }
    }
`;